import React from 'react';
import dynamic from 'next/dynamic';
import { Button, BUTTON_THEMES } from 'ht-styleguide';

import useCartMutationCanAddService from '@store/queries/cart/useCartMutation.canaddservice';

import { getSkuPrice } from '@scenes/LandingsPage/landingspage.utils';

import { TLandingSku } from 'types/landings.types';

import styles from '../landingspage.module.scss';

/* Dynamic Components */
const DevlinkCheckedListDyanmic = dynamic(() => import('@devlink/DevlinkCheckedList').then(module => module.DevlinkCheckedList), { ssr: false });
const DevlinkCheckedListItemDynamic = dynamic(() => import('@devlink/DevlinkCheckedListItem').then(module => module.DevlinkCheckedListItem), {
  ssr: false,
});

type TRenderSkuDetailsProps = {
  sku: TLandingSku;
};

/**
 *
 * @param {TLandingSku} sku
 * @returns {React.JSX.Element | null}
 * @constructor
 */
const RenderSkuDetails: React.FunctionComponent<TRenderSkuDetailsProps> = ({ sku }) => {
  /* Mutation */
  const { mutate: fetchCanAddService } = useCartMutationCanAddService({ skuId: sku.id });

  return sku ? (
    <div className={`${styles.skuInfo} paddingTop-medium paddingX-small2 paddingBottom-small2`}>
      <h2>{sku.name}</h2>
      <h4 className="paddingTop-tiny1 paddingBottom-small2">{getSkuPrice(sku)}</h4>
      <p className="p1 n700">{sku.description}</p>
      <div className="paddingY-small2">
        {sku.skuBullets?.length > 0 && (
          <DevlinkCheckedListDyanmic
            showTitle
            title="Service includes:"
            checkedList={sku.skuBullets?.map((item, index) => (
              <DevlinkCheckedListItemDynamic key={`${sku.id}-${index}`} text={item.bullet} />
            ))}
          />
        )}
      </div>
      <Button theme={BUTTON_THEMES.PRIMARY} onClick={fetchCanAddService}>
        Book Now
      </Button>
    </div>
  ) : null;
};

export default RenderSkuDetails;
